import React from 'react'

import styles from './bottom-sheet.module.scss'
import { Spacers } from './types'

const computedStyle = window.getComputedStyle(document.documentElement)

interface BottomSheetContainerProps {
    children: React.ReactNode
    pt?: Spacers
    pb?: Spacers
    px?: Spacers
}

export const BottomSheetContainer: React.FC<BottomSheetContainerProps> = ({
    children,
    pt = 'm',
    pb = 'm',
    px = 'm',
}) => {
    const ptValue = computedStyle.getPropertyValue(`--spacers-${pt}`)
    const pbValue = computedStyle.getPropertyValue(`--spacers-${pb}`)
    const pxValue = computedStyle.getPropertyValue(`--spacers-${px}`)

    return (
        <div
            className={styles['bottom-sheet__container']}
            id='bottom-sheet__container'
            style={{
                paddingTop: ptValue,
                paddingBottom: pbValue,
                paddingLeft: pxValue,
                paddingRight: pxValue,
            }}
        >
            {children}
        </div>
    )
}
